"use strict";
// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=none"
// @generated from file spwn/shipping/v1/internal_common.proto (package spwn.shipping.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalFulfillmentDestination = exports.InternalGoodsShippingSetting = exports.InternalFulfillment = exports.InternalFulfillmentShippingStatus = void 0;
const protobuf_1 = require("@bufbuild/protobuf");
/**
 * @generated from enum spwn.shipping.v1.InternalFulfillmentShippingStatus
 */
var InternalFulfillmentShippingStatus;
(function (InternalFulfillmentShippingStatus) {
    /**
     * @generated from enum value: INTERNAL_FULFILLMENT_SHIPPING_STATUS_UNSPECIFIED = 0;
     */
    InternalFulfillmentShippingStatus[InternalFulfillmentShippingStatus["UNSPECIFIED"] = 0] = "UNSPECIFIED";
    /**
     * 未発送
     *
     * @generated from enum value: INTERNAL_FULFILLMENT_SHIPPING_STATUS_PENDING = 1;
     */
    InternalFulfillmentShippingStatus[InternalFulfillmentShippingStatus["PENDING"] = 1] = "PENDING";
    /**
     * 発送済み
     *
     * @generated from enum value: INTERNAL_FULFILLMENT_SHIPPING_STATUS_SHIPPED = 2;
     */
    InternalFulfillmentShippingStatus[InternalFulfillmentShippingStatus["SHIPPED"] = 2] = "SHIPPED";
})(InternalFulfillmentShippingStatus = exports.InternalFulfillmentShippingStatus || (exports.InternalFulfillmentShippingStatus = {}));
// Retrieve enum metadata with: proto3.getEnumType(InternalFulfillmentShippingStatus)
protobuf_1.proto3.util.setEnumType(InternalFulfillmentShippingStatus, "spwn.shipping.v1.InternalFulfillmentShippingStatus", [
    { no: 0, name: "INTERNAL_FULFILLMENT_SHIPPING_STATUS_UNSPECIFIED" },
    { no: 1, name: "INTERNAL_FULFILLMENT_SHIPPING_STATUS_PENDING" },
    { no: 2, name: "INTERNAL_FULFILLMENT_SHIPPING_STATUS_SHIPPED" },
]);
/**
 * @generated from message spwn.shipping.v1.InternalFulfillment
 */
class InternalFulfillment extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string order_id = 1;
         */
        this.orderId = "";
        /**
         * @generated from field: string fulfillment_order_id = 2;
         */
        this.fulfillmentOrderId = "";
        /**
         * @generated from field: string fulfillment_request_id = 3;
         */
        this.fulfillmentRequestId = "";
        /**
         * @generated from field: string fulfillment_id = 4;
         */
        this.fulfillmentId = "";
        /**
         * 配送状況
         *
         * @generated from field: spwn.shipping.v1.InternalFulfillmentShippingStatus status = 5;
         */
        this.status = InternalFulfillmentShippingStatus.UNSPECIFIED;
        /**
         * 配送業者
         *
         * @generated from field: string carrier = 7;
         */
        this.carrier = "";
        /**
         * その他の配送業者名
         *
         * @generated from field: string other_carrier_name = 8;
         */
        this.otherCarrierName = "";
        /**
         * 追跡番号
         *
         * @generated from field: string tracking_number = 9;
         */
        this.trackingNumber = "";
        /**
         * 注文日時
         *
         * @generated from field: int32 requested_at = 10;
         */
        this.requestedAt = 0;
        /**
         * 発送完了日時
         *
         * @generated from field: int32 shipped_at = 11;
         */
        this.shippedAt = 0;
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalFulfillment().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalFulfillment().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalFulfillment().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalFulfillment, a, b);
    }
}
exports.InternalFulfillment = InternalFulfillment;
InternalFulfillment.runtime = protobuf_1.proto3;
InternalFulfillment.typeName = "spwn.shipping.v1.InternalFulfillment";
InternalFulfillment.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "fulfillment_order_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "fulfillment_request_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "fulfillment_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "status", kind: "enum", T: protobuf_1.proto3.getEnumType(InternalFulfillmentShippingStatus) },
    { no: 6, name: "destination", kind: "message", T: InternalFulfillmentDestination },
    { no: 7, name: "carrier", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "other_carrier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "tracking_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "requested_at", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "shipped_at", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
]);
/**
 * @generated from message spwn.shipping.v1.InternalGoodsShippingSetting
 */
class InternalGoodsShippingSetting extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string goods_id = 1;
         */
        this.goodsId = "";
        /**
         * @generated from field: int32 shipping_fee = 2;
         */
        this.shippingFee = 0;
        /**
         * @generated from field: string type = 3;
         */
        this.type = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalGoodsShippingSetting().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalGoodsShippingSetting().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalGoodsShippingSetting().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalGoodsShippingSetting, a, b);
    }
}
exports.InternalGoodsShippingSetting = InternalGoodsShippingSetting;
InternalGoodsShippingSetting.runtime = protobuf_1.proto3;
InternalGoodsShippingSetting.typeName = "spwn.shipping.v1.InternalGoodsShippingSetting";
InternalGoodsShippingSetting.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "goods_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "shipping_fee", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message spwn.shipping.v1.InternalFulfillmentDestination
 */
class InternalFulfillmentDestination extends protobuf_1.Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string address_id = 1;
         */
        this.addressId = "";
        /**
         * @generated from field: string postal_code = 2;
         */
        this.postalCode = "";
        /**
         * @generated from field: string prefecture = 3;
         */
        this.prefecture = "";
        /**
         * @generated from field: string city = 4;
         */
        this.city = "";
        /**
         * @generated from field: string street_address = 5;
         */
        this.streetAddress = "";
        /**
         * @generated from field: string name = 7;
         */
        this.name = "";
        /**
         * @generated from field: string phone_number = 8;
         */
        this.phoneNumber = "";
        protobuf_1.proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new InternalFulfillmentDestination().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new InternalFulfillmentDestination().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new InternalFulfillmentDestination().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return protobuf_1.proto3.util.equals(InternalFulfillmentDestination, a, b);
    }
}
exports.InternalFulfillmentDestination = InternalFulfillmentDestination;
InternalFulfillmentDestination.runtime = protobuf_1.proto3;
InternalFulfillmentDestination.typeName = "spwn.shipping.v1.InternalFulfillmentDestination";
InternalFulfillmentDestination.fields = protobuf_1.proto3.util.newFieldList(() => [
    { no: 1, name: "address_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "postal_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "prefecture", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "city", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "street_address", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "residence", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
    { no: 7, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "phone_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
]);
//# sourceMappingURL=internal_common_pb.js.map